const EN_ORDINAL_RULES = new Intl.PluralRules("en", { type: "ordinal" });

const EN_ORDINAL_SUFFIXES: Record<string, string> = {
  one: "st",
  two: "nd",
  few: "rd",
  other: "th",
};

function withEnglishOrdinal(day: number): string {
  return `${day}${EN_ORDINAL_SUFFIXES[EN_ORDINAL_RULES.select(day)]}`;
}

/**
 * Formats the date chip shown at the top of the WhatsApp conversation visual,
 * e.g. "Wed, Jun 10th" — WhatsApp's shorthand style. English gets an ordinal
 * day suffix for extra charm; other languages use their natural short format.
 */
export function formatWhatsAppDateLabel(
  lang: string,
  date: Date = new Date(),
): string {
  const formatter = new Intl.DateTimeFormat(lang, {
    weekday: "short",
    month: "short",
    day: "numeric",
  });

  if (!lang.toLowerCase().startsWith("en")) {
    return formatter.format(date);
  }

  return formatter
    .formatToParts(date)
    .map((part) =>
      part.type === "day" ? withEnglishOrdinal(Number(part.value)) : part.value,
    )
    .join("");
}
